function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogoHelixNoBaseline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    viewBox: "0 0 82.29 41.47",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3,32.55C-3.97,23.05-.7,5.74,12.16,1.36,16.09.07,20.27-.3,24.34.24c0,0,0,.11,0,.11-4.02-.14-8.1.4-11.87,1.81C0,7.1-2.3,22.57,5.3,32.55h0Z",
    style: {
      fill: "#7fba27",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2,9.51c.1-1.51-2.03-1.67-2.17-.22-.2,1.46,2.03,1.75,2.17.22h0ZM16.28,9.52c-.17,2.05-3.28,1.71-3.11-.31.27-2.06,3.28-1.75,3.11.31h0Z",
    style: {
      fill: "#275124",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46,9.18c1.95,2.26,3.91,4.36,5.39,7,.5,1,.65,2.35.23,3.43-.29.61-.59,1.23-.91,1.83-1.58,2.81-3.33,5.03-1.29,8.14.59,1.11,1.32,2.17,1.98,3.28l-.08.06c-2.87-3.44-5.13-5.84-2.39-10.26,0,0,1.8-3.39,1.8-3.39.34-.83.25-1.89-.15-2.74-.82-1.77-3.61-5.59-4.68-7.3,0,0,.08-.06.08-.06h0Z",
    style: {
      fill: "#275124",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.58,6.89c-4.15,2.67-8.06,7.08-7.46,12.29.32,2.42,2.16,4.8,2.59,7.4.72,4.85-3.09,8.87-6.53,11.67,0,0-4.22,3.21-4.22,3.21l-.07-.07c4.65-4.33,12.63-9.88,9.05-17.11-1.62-3.12-2.56-6.88-.85-10.19,1.46-3.11,4.46-6,7.49-7.2h0Z",
    style: {
      fill: "#275124",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.04,26.07v-12.6s1.23,0,1.23,0v5.83s7.56,0,7.56,0v-5.83s1.23,0,1.23,0v12.6h-1.23v-6.34s-7.56,0-7.56,0v6.34s-1.23,0-1.23,0Z",
    style: {
      fill: "#275124",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.73,26.08v-12.6s5.49,0,5.49,0v.88l-3.15-.42c-.55-.07-.92-.11-1.12-.11v5.49c.15,0,.53-.02,1.11-.05l2.95-.18v.83l-2.95-.18c-.59-.04-.96-.05-1.12-.05v6.03c.21,0,.59-.04,1.13-.11l3.19-.41v.88s-5.54,0-5.54,0Z",
    style: {
      fill: "#275124",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.05,13.48h1.22s0,12.24,0,12.24c.23,0,.59-.04,1.08-.11l2.99-.45v.92s-5.29,0-5.29,0v-12.6Z",
    style: {
      fill: "#275124",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.35,26.08v-12.6h1.23v12.6h-1.23Z",
    style: {
      fill: "#275124",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.49,26.08l4.65-6.28-4.28-6.32h1.44s3.54,5.24,3.54,5.24h.11l3.08-5.24h1.44s-4.32,5.71-4.32,5.71l4.68,6.9h-1.44s-3.94-5.82-3.94-5.82h-.11l-3.4,5.81h-1.44Z",
    style: {
      fill: "#275124",
      strokeWidth: 0
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoHelixNoBaseline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-helix-no-baseline.21fbb1ef.svg";
export { ForwardRef as ReactComponent };